import jscookie from 'js-cookie';
import jsmd5 from 'js-md5';
import Vue from 'vue';
import VueSession from 'vue-session';
import { business, moment } from 'neo-utils';
import { POSITIVE_NUMBER } from '@neotrident/utils';
import enums from '@/utils/enums';
import Big from 'big.js';
import { env } from 'dingtalk-jsapi';

Vue.use(VueSession);

const utils = {
  cookie: {
    set: (key, value, domain = business.getDomain(), expires = '') => {
      if (process.env.NODE_ENV == 'development') {
        //开发环境
        jscookie.set(key, value, {
          expires,
        });
      } else {
        //生产环境
        jscookie.set(key, value, {
          expires,
          domain,
        });
      }
    },
    get(key) {
      return jscookie.getJSON(key);
    },
    remove: key => {
      if (process.env.NODE_ENV == 'development') {
        //开发环境
        jscookie.remove(key);
      } else {
        //生产环境
        jscookie.remove(key, { domain: business.getDomain() });
      }
    },
  },
  /**
   * @param {string} property 数据源
   * @description 获取登录用户信息
   */
  getUserInfo(property = 'id') {
    try {
      const accoundInfo = this.getUcInfo().AccountInfo;
      return property === 'id' ? accoundInfo.ID : property === 'name' ? accoundInfo.RealName : accoundInfo;
    } catch (e) {}
  },
  /**
	 * @description 获取cims信息
	 * {
			"Token": "B0136D0D-41C3-4EF0-B79D-8BF5266E9B3A",
			"Identity": "004A286A-7E5C-4A8E-B3A8-ACA7EC4CC073",
			"OrgCode": "Org000023",
			"OrgName": "苏州创腾苏州办科技有限公司",
			"Logo": "/logo/Org000023/20181115101958.jpg",
			"ProductType": "UC",
			"LoginClient": "PC",
			"AccountInfo": {
				"ID": 3,
				"MobilePhone": "13781179110",
				"Email": "liyan.sz@neotrident.com",
				"RealName": "李彦",
				"Photo": "/photo/3/20180129152530.jpg",
				"RegTime": "2017-06-02 13:43:58",
				"LastLoginTime": "2019-01-14 15:43:24",
				"IsOrganAdmin": 1,
				"ReferralCode": null
			},
			"DeptInfo": {
				DeptId: 32,
				DeptName: "研发部",
				IsDeptHeader: 0
				
			}
		}
	 */
  getUcInfo() {
    const cookie = jscookie.getJSON(process.env.VUE_APP_uc_cookie);
    if (cookie) {
      return cookie;
    }
    return {};
  },

  // 判断uc cookie是否存在
  isUcCookieExist() {
    const ucCookie = jscookie.getJSON(process.env.VUE_APP_uc_cookie);
    return !!ucCookie;
  },
  getDeptId() {
    try {
      const cimsCookie = this.getUcInfo();
      if (cimsCookie.DeptInfo) {
        return cimsCookie.DeptInfo.DeptId;
      } else {
        return 0;
      }
    } catch (e) {}
  },
  /**
	 * @description 获取cims信息
	 * cims: {
			"HasWebAuth": true,
			"HasBackAuth": true,
			"UserInfo": {
				"AccountId": 3,
				"RealName": "李彦",
				"IsLock": 0,
				"LabId": 29,
				"LabName": "公测实验室",
			},
			"RoleCodes": {
				"MANAGER": "管理员",
				"ORDERAPPROVE": "领用审批",
				"REQUEST": "领用员",
				"PURCHASE": "采购",
				"WAREHOUSEKEEPER": "库管员",
				"WASTEMANAGER": "废液管理员",
				"TEST": "测试111",
				"CHECK": "核查",
				"DELIVERY": "配送",
				"APPLY": "申购",
				"APPLYAPPROVE": "申购审批",
				"REPORTMANAGER": "报表管理员"
			}
		}
	 */
  getCimsInfo() {
    const ucCookie = jscookie.getJSON(process.env.VUE_APP_uc_cookie);
    const cimsCookie = jscookie.getJSON(process.env.VUE_APP_cims_cookie);

    if (ucCookie && cimsCookie) {
      return cimsCookie;
    }
    return {};
  },
  /**
   * @description 获取时间戳
   */
  getTimesamp() {
    let xhr = null;
    if (window.XMLHttpRequest) {
      xhr = new window.XMLHttpRequest();
    } else {
      xhr = new ActiveObject('Microsoft');
    }
    xhr.open('GET', '/?v=' + new Date().getTime(), false);
    xhr.send(null);
    let date = xhr.getResponseHeader('Date');
    return new Date(date).getTime() / 1000 + 121;
  },
  /**
   * @description 获取年月日对应的时间戳
   */
  getDateTimesamp() {
    const date = new Date();

    return new Date([data.getFullYear(), data.getMonth(), data.getDate()].join('-')).getTime() / 1000 + 121;
  },
  /**
   * 计算本月第一天
   * @obj {null} 无
   * @return 上周的时间
   */
  getFirstdayOfMonth() {
    var myDate = new Date(),
      year = myDate.getFullYear(),
      month = myDate.getMonth() + 1;

    if (month < 10) {
      month = '0' + month;
    }

    var currentDate = year + '-' + month + '-01';
    return currentDate;
  },
  /**
   * @param {object} obj 源数组
   * @description 深拷贝
   */
  deepCopy(obj) {
    let objClone = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === 'object') {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          //判断ojb子元素是否为对象，如果是，递归复制
          if (obj[key] && typeof obj[key] === 'object') {
            objClone[key] = this.deepCopy(obj[key]);
          } else {
            //如果不是，简单复制
            objClone[key] = obj[key];
          }
        }
      }
    }
    return objClone;
  },
  /**
   * @description 睡眠，单位毫秒
   */
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  },
  /**
   * @param {String} key URL参数
   * @description 从URL中获取参数值
   */
  getParams(key) {
    const url = window.location.search;
    let paramVal = '';
    if (!url) {
      return paramVal;
    }
    const keyValueArr = url.split('?')[1].split('&');

    if (!key) {
      return keyValueArr;
    }

    keyValueArr.forEach(item => {
      const keyValue = item.split('=');
      if (keyValue[0] === key) {
        paramVal = keyValue[1];
      }
    });
    return decodeURIComponent(paramVal);
  },
  /**
   * @description 滚动到顶部
   */
  scrollTop() {
    if (!window.requestAnimationFrame) {
      window.requestAnimationFrame =
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (callback) {
          return window.setTimeout(callback, 1000 / 60);
        };
    }
    const difference = Math.abs(from - to);
    const step = Math.ceil((difference / duration) * 50);

    const scroll = (start, end, step) => {
      if (start === end) {
        endCallback && endCallback();
        return;
      }

      let d = start + step > end ? end : start + step;
      if (start > end) {
        d = start - step < end ? end : start - step;
      }

      if (el === window) {
        window.scrollTo(d, d);
      } else {
        el.scrollTop = d;
      }
      window.requestAnimationFrame(() => scroll(d, end, step));
    };
    scroll(from, to, step);
  },
  /**
   * @description 计算当前的时间
   */
  getcurDate() {
    let myDate = new Date(),
      year = myDate.getFullYear(),
      month = myDate.getMonth() + 1,
      dates = myDate.getDate();

    if (dates < 10) {
      dates = '0' + dates;
    }
    if (month < 10) {
      month = '0' + month;
    }

    let currentDate = year + '-' + month + '-' + dates;

    return currentDate;
  },
  /**
   * @description 计算一周前的时间
   */
  getPrevWeek() {
    let d = new Date(),
      yesterday_milliseconds = d.getTime() - 7000 * 60 * 60 * 24,
      yesterday = new Date();

    yesterday.setTime(yesterday_milliseconds);

    let strYear = yesterday.getFullYear(),
      strDay = yesterday.getDate(),
      strMonth = yesterday.getMonth() + 1;

    if (strDay < 10) {
      strDay = '0' + strDay;
    }
    if (strMonth < 10) {
      strMonth = '0' + strMonth;
    }
    return strYear + '-' + strMonth + '-' + strDay;
  },
  // 是否是sso登录状态
  isSSO() {
    const ucStorage = this.getUcInfo();
    return ucStorage && ucStorage.LoginType === enums.loginType.SSO;
  },
  // 是否是单点登录进入系统
  getSSOLogoutUrl() {
    const ucStorage = this.getUcInfo();
    return ucStorage.SSO?.LogoutUrl || ucStorage.SSO?.OriginUrl;
  },
  getSystemLogoutUrl() {
    // 如果是单点登录进入系统，则退出时跳转到单点登录的退出地址；否则跳转到登录页
    const logoutUrl = this.isSSO() ? this.getSSOLogoutUrl() : `${config.site.uc}/#/login`;
    return logoutUrl;
  },
  /**
   * @description 退出系统
   */
  turnToLoginPage(isManualLogout) {
    const ssoLogoutUrl = this.getSystemLogoutUrl();
    business.removeCookies();
    if (isManualLogout) {
      this.skipTo(ssoLogoutUrl);
    } else {
      const logoutUrl = this.isSSO() ? ssoLogoutUrl : `${ssoLogoutUrl}?redirect=${encodeURIComponent(window.location.href)}`;
      this.skipTo(logoutUrl);
    }
  },
  /**
   * @description 获取ketcher
   */
  getKetcher() {
    let ketcherFrame = document.getElementById('ketcher-id');
    let ketcher = null;
    if ('contentDocument' in ketcherFrame) ketcher = ketcherFrame.contentWindow.ketcher;
    // IE7
    else ketcher = document.frames['ketcherFrame'].window.ketcher;
    return ketcher;
  },
  /**
   * @description 获取Molfile
   */
  getMolfile() {
    return this.getKetcher().getMolfile();
  },
  /**
   * @description 获取Smiles
   */
  getSmiles() {
    return this.getKetcher().getSmiles();
  },
  // 日期，在原有日期基础上，增加days天数，默认增加1天
  addDate(days = 1, date) {
    date = date ? new Date(date) : new Date();
    date.setDate(date.getDate() + days);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return date.getFullYear() + '-' + this.getFormatDate(month) + '-' + this.getFormatDate(day);
  },
  // 日期月份/天的显示，如果是1位数，则在前面加上'0'
  getFormatDate(arg) {
    if (arg == undefined || arg == '') {
      return '';
    }

    var re = arg + '';
    if (re.length < 2) {
      re = '0' + re;
    }

    return re;
  },
  //生成过效期
  isExpiry(iminentExpirationDay, expiryDateStr, vm) {
    if (!expiryDateStr) {
      return;
    }
    const expireDateState = [vm.$i18n.t('page.overExpiryTime'), vm.$i18n.t('page.withExpiryTime'), vm.$i18n.t('page.inExpiryTime')];
    const curDate = moment();
    const closeExpiryDate = moment(expiryDateStr).subtract(iminentExpirationDay, 'days');
    const units = 'day';
    if (curDate.isAfter(expiryDateStr, units)) {
      return `<span class='wrong-date'>${expireDateState[0]}</span>`; //过效期
    } else if (curDate.isSameOrBefore(closeExpiryDate, units)) {
      return `<span class='right-date'>${expireDateState[2]}</span>`; //效期内
    } else {
      return `<span class='normal-date'>${expireDateState[1]}</span>`; //近效期
    }
  },
  //删除数组中指定下标的元素
  removeItem(data, id, key = 'ID') {
    data.map((item, index) => {
      if (item[key] === id) {
        data.splice(index, 1);
      }
    });
  },
  //页面权限判断
  canAccess(pageAccessRoles) {
    const roles = utils.getCimsInfo().RoleCodes;
    if (roles) {
      const userRoleKeys = Object.keys(roles);
      if (pageAccessRoles.some(key => userRoleKeys.includes(key))) {
        return true;
      }
    }

    return false;
  },
  //iframe的高度自适应
  fixedIframeHeight(id = 'materielframe') {
    var num = 0;
    var timer = setInterval(function () {
      var iframe = document.getElementById(id);
      try {
        var bHeight = iframe.contentWindow.document.body.scrollHeight;
        var dHeight = iframe.contentWindow.document.documentElement.scrollHeight;
        var height = Math.max(bHeight, dHeight);
        iframe.height = height;
        num++;
        if (num === 4) {
          clearInterval(timer);
        }
      } catch (ex) {}
    }, 1000);
  },
  /**
   * @description 生成header
   */
  md5(str) {
    return str ? jsmd5(str) : '';
  },
  getSystemLanguage() {
    const ucCookie = this.cookie.get(process.env.VUE_APP_uc_cookie);
    let lang = null;
    if (ucCookie) {
      lang = ucCookie.Lang;
    }
    if (!lang) {
      lang = (navigator.language || navigator.browserLanguage).toLowerCase();
    }
    lang = lang.includes('zh') ? 'zh' : lang.includes('en') ? 'en' : 'zh';
    return lang;
  },
  //正整数
  isInteger(num) {
    return /(^[1-9]\d*$)/.test(num);
  },
  //正数
  isPositive(num) {
    return POSITIVE_NUMBER.test(num);
  },
  // 数字
  isNumber(num) {
    if (typeof num === 'number') return true;
    return isNaN(Number(num)) ? false : true;
  },
  //图片路径增加随机数
  addRandom2Url(url) {
    return url.replace(/#/g, '%23') + '?v=' + Math.random();
  },
  //自定义小数长度
  toFixed(value, length) {
    if (value && typeof value === 'number' && value.toString().indexOf('.') > -1) {
      const values = value.toString().split('.');
      if (values[1].length > length) {
        values[1] = values[1].substr(0, length);
      }
      return values.join('.');
    }

    return value;
  },
  //根据位数获取放大的倍数
  getScale(scale) {
    let value = '1';
    if (scale) {
      for (let index = 0; index < scale.length; index++) {
        value += '0';
      }
    }

    return value * 1;
  },
  //获取时间戳
  getTimeStamp() {
    return moment().valueOf();
  },
  getAppPrefix() {
    return process.env.NODE_ENV === 'production' ? config.site.cims : '';
  },
  getStructImagePrefix() {
    const prefix = this.getAppPrefix();
    return {
      structurePrefix: prefix + process.env.VUE_APP_structurePrefix,
      materielPrefix: prefix + process.env.VUE_APP_materielPrefix,
    };
  },
  pickBy(object, predicate) {
    let obj = null;
    Object.keys(object).forEach(key => {
      if (predicate(key)) {
        obj = object[key];
      }
    });

    return obj;
  },
  encodeURIComponent(str) {
    return str ? str.replace(/#/g, '%23') : str;
  },
  //去掉斜杆
  formatSlash(str) {
    return str ? str.replace(/\//g, '') : str;
  },
  //初始化数组
  initArray(length, value) {
    return Array.from({ length }).map(() => {
      return typeof value === 'object' ? { ...value } : value;
    });
  },
  getADecimalPlaceLength(value) {
    if (/^\d+\.\d+$/.test(value)) {
      const arr = value.toString().split('.');
      return arr[1].length;
    }
    return 0;
  },
  /**
   * 回到页面顶部
   * @param {延迟时间} duration
   * @returns
   */
  scrollToTop(duration = 200) {
    if (document.scrollingElement.scrollTop === 0) return;

    const totalScrollDistance = document.scrollingElement.scrollTop;
    let scrollY = totalScrollDistance,
      oldTimestamp = null;

    function step(newTimestamp) {
      if (oldTimestamp !== null) {
        scrollY -= (totalScrollDistance * (newTimestamp - oldTimestamp)) / duration;
        if (scrollY <= 0) return (document.scrollingElement.scrollTop = 0);
        document.scrollingElement.scrollTop = scrollY;
      }
      oldTimestamp = newTimestamp;
      window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  },
  isNullOrEmpty(value, strict = false) {
    if (strict) {
      return value === null || value === undefined;
    } else {
      return value == null || value === '' || value === undefined;
    }
  },
  // 获取年月日时分秒字符串
  getDateTimeString(date) {
    return moment(date).format('YYYYMMDDHHmmss');
  },
  /**
   * 页面跳转
   * @param {string} url 网址
   * @returns void 0
   */
  skipTo(url) {
    // 通过设置__DEV__, 手动禁止页面跳转，方便在云端调试bug
    if (!!window.localStorage.getItem('__DEV__')) {
      return;
    }
    const prefix = url && url.startsWith('http') ? '' : this.getAppPrefix();
    window.location.href = `${prefix}${url}`;
  },
  /**
   * 限制6位小数
   * @returns 返回替换后的字符串
   */
  // /[^\d.]|^\./g 非数字非.
  // /(\.(\d)*)(\.)+/g 多.
  // /^(-)*(\d+)\.(\d\d\d\d\d\d).*$/g 6位小数
  limitDecimalsF(value) {
    return `${value}`
      .replace(/[^\d.]|^\./g, '')
      .replace(/(\.(\d)*)(\.)+/g, '$1')
      .replace(/^(\d+)\.(\d\d\d\d\d\d).*$/g, '$1.$2');
  },
  generateDangerousType(materiel) {
    const labels = [];
    enums.controlType.map(key => {
      if (materiel[key]) {
        labels.push(this.$t(`page.${key}`));
      }
    });

    return labels.join(',');
  },
  // minus
  minus(value1, value2) {
    return new Big(+value1).minus(+value2).toNumber();
  },
  // plus
  plus(value1, value2) {
    return new Big(value1).plus(value2).toNumber();
  },
  // 字符串首字母大写
  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
  // 遍历自定义表单的所有节点
  traverseNodes(nodes, callback) {
    for (const item of nodes) {
      if (item.columns) {
        for (const j in item.columns) {
          const node = item.columns[j];
          if (node) {
            this.traverseNodes(node, callback);
          }
        }
      } else {
        callback(item);
      }
    }
  },
  // 物料是否来自cms
  isFromCms(source) {
    if (!source || typeof source !== 'string') return false;
    return source.toLocaleLowerCase() === 'cms';
  },
  // 渲染table column header的自动填充图标
  renderAutoFillHeader(title, autoFillFunc, isRequired = false) {
    return h =>
      h('div', [
        isRequired ? h('span', { style: { color: 'red' } }, '*') : null,
        h('span', {
          domProps: {
            innerText: title,
          },
        }),
        h(
          'Tooltip',
          {
            props: {
              content: this.$i18n.t('key24'),
              trigger: 'hover',
              theme: 'light',
              placement: 'top',
              transfer: true,
            },
            style: {
              marginLeft: '2px',
            },
          },
          [
            h('img', {
              attrs: {
                src: require('@/assets/img/fillDown.png'),
              },
              style: {
                cursor: 'pointer',
                width: '12px',
                height: '12px',
                position: 'relative',
                top: '1px',
              },
              on: {
                click: autoFillFunc,
              },
            }),
          ]
        ),
      ]);
  },
  // 写个方法，把C15 H16 O5格式化成C<sub>15</sub>H<sub>16</sub>O<sub>5</sub>
  formatChemicalFormula(formula) {
    if (!formula) return '';
    return formula.replace(/(\d+)/g, '<sub>$1</sub>');
  },
  isEmpty(value) {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    if (value instanceof Array && value.length === 0) {
      return true;
    }
    if (value instanceof Object) {
      if (value instanceof Date) return false;
      if (Object.keys(value).length === 0) return true;
    }
    return false;
  },
  // 渲染使用量的修改原因
  renderToolTip(contentKey, row, h) {
    const content = row[contentKey];
    return h('Tooltip', {
      props: {
        trigger: 'hover',
        theme: 'light',
        placement: 'top',
        transfer: true,
      },
      style: {
        marginLeft: '2px',
      },
      scopedSlots: {
        default: () =>
          h('Icon', {
            props: { type: 'ios-information', theme: 'light', size: 24 },
            style: {
              color: 'red',
              position: 'relative',
              top: '-1px',
            },
          }),
        content: () =>
          h(
            'div',
            {},
            content.split('__').map(item => h('div', item))
          ),
      },
    });
  },
  curry(fn) {
    return function curried(...args) {
      if (args.length >= fn.length) {
        return fn.apply(this, args);
      } else {
        return function (...args2) {
          return curried.apply(this, args.concat(args2));
        };
      }
    };
  },
  renderRequiredTitle(h, { column }) {
    return h('div', [h('span', { style: { color: 'red' } }, '*'), h('span', column.title)]);
  },
  // 获取本地UTC时间
  getUtcTime(time) {
    const currentOffset = moment().utcOffset();
    const newTime = moment(time).add(currentOffset, 'minutes');
    return moment(newTime).utc();
  },
  // 根据流程ID将试剂信息分组
  groupMaterialsByFlowId(materials, opetionFlows) {
    if (!Array.isArray(materials) || !Array.isArray(opetionFlows)) {
      return {};
    }
    opetionFlows.forEach(flow => {
      materials.forEach(material => {
        if ('WarehouseId' in flow && material.WarehouseId === flow.WarehouseId) {
          material.FlowId = flow.FlowId;
        } else if ('Amount' in flow && new Big(material.TotalPrice).eq(flow.Amount)) {
          material.FlowId = flow.FlowId;
        }
      });
    });
    return materials.reduce((grouped, item) => {
      const flowId = item.FlowId;
      if (!grouped[flowId]) {
        grouped[flowId] = [];
      }
      grouped[flowId].push(item);
      return grouped;
    }, {});
  },
  /**
   * @description 双人双锁：从数据行集合中收集需要共同操作人签名的仓库（按仓库去重）
   * @param {Array} rows 数据行集合，行内需含 IsDualControl / WarehouseId / WarehouseName
   * @returns {Array<{WarehouseId: number, WarehouseName: string}>}
   */
  collectDualControlWarehouses(rows) {
    const map = new Map();
    (Array.isArray(rows) ? rows : []).forEach(row => {
      if (row && row.IsDualControl === 1 && !map.has(row.WarehouseId)) {
        map.set(row.WarehouseId, { WarehouseId: row.WarehouseId, WarehouseName: row.WarehouseName });
      }
    });
    return [...map.values()];
  },
};

export default utils;

export function downLoadBlob(data, fileName, type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8') {
  if (!data) {
    return false;
  }

  const blob = data instanceof Blob ? data : new Blob([data], { type });
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.style.display = 'none';
  link.download = fileName;
  link.href = downloadUrl;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);

  return true;
}

export function isDingTalkEnv() {
  return env.platform !== 'notInDingTalk';
}

/**
 * 打开新窗口, 钉钉环境下添加ddtab参数
 * @param url
 */
export function openWindow(url) {
  const newUrl = getDingTalkLink(url);
  window.open(newUrl);
}

/**
 * 动态生成钉钉跳转链接
 */
export function getDingTalkLink(url) {
  const hasSearch = url.includes('?');
  let ddtab = '';
  if (isDingTalkEnv()) {
    ddtab = hasSearch ? `&ddtab=true` : `?ddtab=true`;
  }
  return `${url}${ddtab}`;
}

export function isNumberString(value) {
  const reg = /^-?(0|[1-9]\d*)(\.\d+)?$/;
  return reg.test(value);
}

// 根据对象的字段，从另一个对象中拷贝对应字段的值
export function pickValues(target, source) {
  Object.keys(target).forEach(key => {
    if (source.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  });
}
